import { SVGFC } from '@repo/toolkit/types'

const LocationFourIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.0001 21.9703C14.5295 17.4997 13.3825 19.4997 17.0883 12.9409C17.706 11.8821 18.5001 10.0879 18.5001 8.88206C18.5001 6.4703 17.1766 4.26441 15.0589 3.11736C10.8236 0.793827 5.4707 3.85265 5.4707 8.88206C5.4707 10.1174 6.29423 11.9115 6.88247 12.9409C12.5883 22.9997 10.9707 20.1174 12.0001 21.9703ZM11.7648 2.91147C12.1766 2.91147 13.3825 2.85265 14.8236 3.61736C17.1178 4.85265 18.1472 7.35265 17.9119 9.20559C17.7354 10.9703 16.3531 13.0585 12.0001 20.7644C10.1178 17.4115 11.0883 19.1762 7.41188 12.6468C7.00011 11.9409 6.206 10.2938 6.08835 9.235C5.73541 6.41147 8.08835 3.08794 11.7648 2.91147Z"
        fill={color}
      />
      <path
        d="M8.73495 8.94141V12.7943C8.73495 12.9708 8.8526 13.0885 9.02907 13.0885H10.9997C11.1761 13.0885 11.2938 12.9708 11.2938 12.7943V10.2061H12.6761V12.7943C12.6761 12.9708 12.7938 13.0885 12.9702 13.0885H14.9408C15.1173 13.0885 15.235 12.9708 15.235 12.7943V8.94141H16.5585C16.6761 8.94141 16.7938 8.85317 16.8232 8.76494C16.8526 8.6767 16.8232 8.52964 16.735 8.44141L12.2055 4.38258C12.0879 4.29435 11.9408 4.29435 11.8232 4.38258L7.23495 8.41199C7.02907 8.58846 7.14672 8.91199 7.44083 8.91199H8.73495V8.94141Z"
        fill={color}
      />
    </svg>
  )
}

export default LocationFourIcon
